import React from 'react';
import { motion } from 'framer-motion';
import { SacredGeometry } from './SacredGeometry';
export function MetodoLlave() {
  return <section className="relative w-full bg-cream overflow-hidden" data-id="element-222">
      {/* Decorative geometry */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] translate-x-1/3 -translate-y-1/4 pointer-events-none" data-id="element-223">
        <SacredGeometry data-id="element-224" />
      </div>
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] -translate-x-1/3 translate-y-1/4 pointer-events-none" data-id="element-225">
        <SacredGeometry data-id="element-226" />
      </div>

      {/* PART 1 — El Método Llave */}
      <div className="relative z-10 py-32 px-6" data-id="element-227">
        <div className="max-w-3xl mx-auto" data-id="element-228">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-serif italic text-teal text-sm md:text-base text-center uppercase mb-6" style={{
          letterSpacing: '0.25em'
        }} data-id="element-229">
            Acceso al Campo Invisible
          </motion.p>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-serif text-teal-dark text-4xl md:text-5xl lg:text-6xl text-center leading-tight mb-16" data-id="element-230">
            El Método Llave
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6 text-lg md:text-xl text-gray-700 font-light leading-relaxed" data-id="element-231">
            <p data-id="element-232">
              Lo que hago en Las Llaves de tu Alma
              <span className="text-teal-dark font-medium" data-id="element-233">
                {' '}
                no es un servicio genérico.
              </span>
            </p>
            <p data-id="element-234">
              Es un método propio — desarrollado y refinado a través de años de
              trabajo real, de transformación personal profunda, y de cientos de
              horas dentro de campos energéticos que me mostraron cosas que
              ningún manual podría haber anticipado.
            </p>
            <p className="font-serif italic text-xl md:text-2xl text-teal-dark border-l-2 border-gold pl-6 py-2 my-8" data-id="element-235">
              Lo llamo Método Llave porque eso es exactamente lo que hace:
              <br data-id="element-236" />
              abre el acceso a una capa de información invisible — pero
              absolutamente real y determinante en lo que vivís, sentís y
              repetís.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mt-16 flex flex-col items-center text-center font-serif text-teal-dark" data-id="element-237">
            <div className="text-xl md:text-2xl italic mb-2" data-id="element-238">
              No trabajo con suposiciones.
            </div>
            <div className="text-xl md:text-2xl italic mb-2" data-id="element-239">
              No trabajo con protocolos genéricos.
            </div>
            <div className="text-xl md:text-2xl" data-id="element-240">
              Trabajo con{' '}
              <span className="text-teal font-medium not-italic" data-id="element-241">
                lo que tu campo muestra
              </span>
              <span className="italic" data-id="element-242"> en el momento exacto del trabajo.</span>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Ornamental divider */}
      <div className="relative z-10 flex items-center justify-center px-6 py-8" data-id="element-243">
        <div className="h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent w-32" data-id="element-244"></div>
        <div className="mx-4 text-gold text-2xl font-serif" data-id="element-245">✦</div>
        <div className="h-px bg-gradient-to-r from-transparent via-teal/30 to-transparent w-32" data-id="element-246"></div>
      </div>

      {/* PART 2 — Una palabra sobre el péndulo hebreo */}
      <div className="relative z-10 py-32 px-6" data-id="element-247">
        <div className="max-w-3xl mx-auto" data-id="element-248">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="font-serif italic text-teal text-sm md:text-base text-center uppercase mb-6" style={{
          letterSpacing: '0.25em'
        }} data-id="element-249">
            Una palabra sobre
          </motion.p>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="font-serif text-teal-dark text-4xl md:text-5xl lg:text-6xl text-center leading-tight mb-16" data-id="element-250">
            El péndulo hebreo
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="grid grid-cols-1 md:grid-cols-5 gap-12 items-center mb-16" data-id="element-251">
            {/* Pendulum SVG */}
            <div className="md:col-span-2 flex justify-center" data-id="element-252">
              <svg viewBox="0 0 200 280" className="w-40 md:w-48 h-auto" data-id="element-253">
                {/* String */}
                <line x1="100" y1="20" x2="100" y2="140" stroke="#0A2E2C" strokeWidth="1.5" data-id="element-254" />
                {/* Top anchor */}
                <circle cx="100" cy="20" r="3" fill="#0A2E2C" data-id="element-255" />
                {/* Pendulum body — elongated hebrew style */}
                <ellipse cx="100" cy="200" rx="28" ry="55" fill="none" stroke="#00A99D" strokeWidth="2" data-id="element-256" />
                <ellipse cx="100" cy="200" rx="20" ry="40" fill="none" stroke="#00A99D" strokeWidth="1" opacity="0.5" data-id="element-257" />
                {/* Hebrew sacred geometry pattern on pendulum */}
                <circle cx="100" cy="180" r="6" fill="none" stroke="#F5E6C8" strokeWidth="1.5" data-id="element-258" />
                <circle cx="100" cy="200" r="6" fill="none" stroke="#F5E6C8" strokeWidth="1.5" data-id="element-259" />
                <circle cx="100" cy="220" r="6" fill="none" stroke="#F5E6C8" strokeWidth="1.5" data-id="element-260" />
                {/* Tip */}
                <line x1="100" y1="255" x2="100" y2="275" stroke="#0A2E2C" strokeWidth="1.5" data-id="element-261" />
                <circle cx="100" cy="275" r="2" fill="#F5E6C8" data-id="element-262" />
                {/* Energy waves */}
                <circle cx="100" cy="200" r="70" fill="none" stroke="#00A99D" strokeWidth="0.5" opacity="0.3" data-id="element-263" />
                <circle cx="100" cy="200" r="85" fill="none" stroke="#00A99D" strokeWidth="0.5" opacity="0.2" data-id="element-264" />
              </svg>
            </div>

            <div className="md:col-span-3 space-y-5 text-lg text-gray-700 font-light leading-relaxed" data-id="element-265">
              <p data-id="element-266">
                La mayoría de las personas que conocen el péndulo lo asocian a
                una herramienta de diagnóstico. Algo que oscila y señala.
              </p>
              <p className="font-serif italic text-xl text-teal-dark" data-id="element-267">
                El péndulo hebreo es otra cosa.
              </p>
              <p data-id="element-268">
                No es solo un instrumento de lectura — es un{' '}
                <span className="text-teal-dark font-medium" data-id="element-269">
                  instrumento de acción.
                </span>
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="space-y-6 text-lg md:text-xl text-gray-700 font-light leading-relaxed" data-id="element-270">
            <p data-id="element-271">
              Trabaja con el{' '}
              <span className="text-teal-dark font-medium" data-id="element-272">idioma hebreo</span>,
              donde cada letra tiene forma, un nombre y un valor numérico
              (gematría) que representa una energía arquetípica. Funciona como
              una tecnología para transferir energía de la luz divina al mundo
              físico, donde las palabras actúan como{' '}
              <span className="text-teal-dark font-medium" data-id="element-273">"nanorobots"</span>{' '}
              que unen fuerzas espirituales.
            </p>
            <p className="font-serif italic text-2xl md:text-3xl text-teal-dark text-center py-6" data-id="element-274">
              No es metáfora. No es símbolo.
            </p>
            <p data-id="element-275">
              Cuando el péndulo hebreo trabaja sobre un campo, algo se mueve
              realmente. Se libera lo que estaba retenido. Se rompen patrones
              que operaban por inercia. Se restaura lo que estaba desalineado.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="mt-16 bg-white rounded-2xl p-10 md:p-12 border border-teal/15 shadow-sm" data-id="element-276">
            <p className="text-gray-700 font-light leading-relaxed text-lg mb-6" data-id="element-277">
              Es por eso que cada sesión requiere tiempo real y presencia
              completa. Y es por eso que{' '}
              <span className="text-teal-dark font-medium" data-id="element-278">
                no realizo más de una por día.
              </span>
            </p>
            <p className="text-gray-700 font-light leading-relaxed text-lg mb-6" data-id="element-279">
              No porque sea un proceso lento — sino porque es un proceso real.
              Profundo. Que requiere precisión, presencia y cuidado.
            </p>
            <p className="font-serif italic text-2xl text-teal text-center pt-4 border-t border-teal/10" data-id="element-280">
              Y eso no se apura.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}